export const TooltipIdStr = (value = '') => {
  // Convert to string
  if (typeof value !== 'string') value = value.toString();
  // Dont start with a number
  if (value[0] && !isNaN(value[0])) {
    value = 'g-' + value;
  }
  // Remove NON letters or numbers
  return value.replace(/[^0-9a-zA-Z]/g, '').toLowerCase();
};